module.exports = __webpack_public_path__ + "static/img/tenor.aa5f34f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tenor.gif
// module id = 1615
// module chunks = 3 4 5 6 8